import Image from "next/image";
import { cn } from "@/lib/utils";

export interface ImageSlotProps {
  src: string;
  alt?: string;
  /** Render as a circle (object-cover, rounded-full). Defaults to false. */
  rounded?: boolean;
  /** Max width in rem. Defaults to 40 (400px). */
  maxWidth?: number;
}

export function ImageSlot({
  src,
  alt = "",
  rounded = false,
  maxWidth = 40,
}: ImageSlotProps) {
  if (!src) return null;

  return (
    <div className="flex justify-center">
      <Image
        src={src}
        alt={alt}
        width={400}
        height={400}
        loading="eager"
        className={cn(
          "w-full h-auto",
          rounded && "rounded-full aspect-square object-cover",
        )}
        style={{ maxWidth: `${maxWidth}rem` }}
      />
    </div>
  );
}

export default ImageSlot;
